import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';

import dateUtils from '../../../util/dates';
import dataUtils from '../../../util/dataUtils';
import highchartFactory from '../../../util/highcharts';
const highchartUtils = highchartFactory(Highcharts);

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    // height: (9 / 20 * 100) + '%',
    backgroundColor: '#fff',
    type: 'area',
  },
  title: {
    text: '',
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    type: 'datetime',
    tickmarkPlacement: 'on',
    title: {
      enabled: false,
    },
    labels: {
      style: {
        fontSize: '5px',
      },
    },
    gridLineWidth: 1,
    gridLineColor: '#F5F5F5',
  },
  yAxis: {
    opposite: false,
    allowDecimals: false,
    title: {
      enabled: false,
    },
    labels: {
      style: {
        fontSize: '6px',
      },
    },
    gridLineWidth: 1,
    gridLineColor: '#F5F5F5',
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    area: {
      stacking: 'normal',
      lineColor: '#F5F5F5',
      lineWidth: 0,
      marker: {
        enabled: false,
      },
    },
    series: {
      events: {},
    },
  },
  series: [],
};

class CFDChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    this.updateTimeLabelsFormat(this.props.dateFormat);

    if (this.props.data && this.props.data.length) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.updateChart(prevProps.data);
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateTimeLabelsFormat(this.props.dateFormat);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart(oldData) {
    const diff = dataUtils.getDiff(oldData, this.props.data, 'data');
    highchartUtils.updateSeries(diff, this.chart);
    this.chart.redraw();
  }

  updateTimeLabelsFormat(dateFormat) {
    let config = { xAxis: {} };
    config.xAxis.dateTimeLabelFormats = dateUtils.createHighchartFormats(dateFormat);

    this.chart.update(config);
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dateFormat: state.filters.cfd.dateFormat,
  };
};

export default connect(mapStateToProps)(CFDChart);
